/**
 * NEP rotating badge — header tagline carousel.
 *
 * Cycles through 5 marketing slides every 4 seconds with a slide-up
 * animation (`.slide.active`). Visitor clicks to advance manually.
 *
 * The original AI-IDE design has this baked into the hero. We extract as
 * a reusable component because both home and student/parent/school heroes
 * use the same NEP badge.
 */
import { useEffect, useState, useCallback } from 'react';

const DEFAULT_SLIDES = [
  'NEP 2020 Aligned • Verified NCERT Mapping',
  'Thinks out loud — so students think deeper',
  'CBSE, ICSE & 12+ State Boards Covered',
  'Students retain 3x more vs passive study',
  'Zero rote. 100% understanding.',
];

const ROTATION_MS = 4000;

export default function NepBadge({ slides = DEFAULT_SLIDES }) {
  const [index, setIndex] = useState(0);
  const total = slides.length;

  const advance = useCallback(() => {
    setIndex((i) => (i + 1) % total);
  }, [total]);

  useEffect(() => {
    const id = setInterval(advance, ROTATION_MS);
    return () => clearInterval(id);
  }, [advance]);

  return (
    <div
      className="nep-badge interactive-gimmick"
      id="nep-gimmick-badge"
      role="button"
      tabIndex={0}
      title="Click to advance"
      onClick={advance}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          advance();
        }
      }}
      data-testid="nep-gimmick-badge"
    >
      <div className="badge-glow-border" />
      <span className="pulse-dot" />
      <div className="badge-text-slider">
        {slides.map((text, i) => (
          <div
            key={i}
            className={`slide${i === index ? ' active' : ''}`}
            aria-hidden={i !== index}
          >
            {text}
          </div>
        ))}
      </div>
    </div>
  );
}
